import type { QueryClient } from '@tanstack/react-query';

/** Wearable aggregates can share a short freshness window across dashboard panels.
 * Retrying a timeout immediately can start another expensive server calculation
 * while the first is still running. Errors remain retryable through normal refetch.
 */
export const metricsQueryPolicy = { staleTime: 60_000, retry: false } as const;

/** Cached metrics must be re-authorised after a login or logout in the same tab. */
export function clearMetricsQueries(client: QueryClient) {
  client.removeQueries({ queryKey: ['metrics'] });
  client.removeQueries({ queryKey: ['reports', 'segmentComparison'] });
}
